export default __webpack_public_path__ + "static/media/20p.92532da5.svg";